import { Component, input, output } from '@angular/core';
import { MenuDropdownButtonComponent } from '@sandbox-platform/shared-ui';
import { SetupDropdownData } from '../desktop-menu.config';
import { NavDropdownComponent } from './nav-dropdown.component';

@Component({
  standalone: true,
  imports: [NavDropdownComponent, MenuDropdownButtonComponent],
  selector: 'lib-setup-dropdown',
  template: `
    <lib-nav-dropdown
      label="Setup"
      [isOpen]="isOpen()"
      (toggleClicked)="toggleClicked.emit()"
    >
      @if (items().organization.length) {
      <div class="py-2 border-b border-gray-700">
        @for (item of items().organization; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      } @if (items().industry.length) {
      <div class="py-2 border-b border-gray-700">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Expertise
        </div>
        @for (item of items().industry; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      } @if (items().attendance.length) {
      <div class="py-2">
        <div
          class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider"
        >
          Attendance
        </div>
        @for (item of items().attendance; track item.routerLink) {
        <lib-menu-dropdown-button
          [item]="item"
          (onItemClick)="navigate.emit($event)"
        />
        }
      </div>
      }
    </lib-nav-dropdown>
  `,
})
export class SetupDropdownComponent {
  items = input.required<SetupDropdownData>();
  isOpen = input.required<boolean>();

  toggleClicked = output<void>();
  navigate = output<string>();
}
